import { render, staticRenderFns } from "./ViewReservationDialog.vue?vue&type=template&id=dbcf28ea&lang=pug&"
import script from "./ViewReservationDialog.vue?vue&type=script&lang=js&"
export * from "./ViewReservationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports